"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));

var AndroidIcon = function AndroidIcon(props) {
  return /*#__PURE__*/_react["default"].createElement(_SvgIcon["default"], (0, _extends2["default"])({
    className: 'text-light dark:text-ultra-light'
  }, props, {
    viewBox: '0 0 100 100',
    style: {
      fill: 'currentColor'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M60.623,18.128l3.359-6.136c0.18-0.322,0.062-0.733-0.262-0.909c-0.328-0.179-0.734-0.056-0.906,0.265l-3.396,6.197   c-2.855-1.267-6.053-1.981-9.432-1.978c-3.373-0.003-6.564,0.707-9.411,1.972l-3.398-6.184c-0.174-0.326-0.584-0.445-0.904-0.267   c-0.326,0.174-0.446,0.583-0.265,0.905l3.362,6.13c-6.606,3.408-11.068,9.893-11.064,17.341l43.365-0.004   C71.673,28.014,67.219,21.54,60.623,18.128z M40.124,27.609c-0.999-0.002-1.812-0.815-1.812-1.818c0-0.998,0.813-1.818,1.813-1.818   c1.006,0,1.819,0.82,1.82,1.818C41.945,26.794,41.131,27.609,40.124,27.609z M59.87,27.605c-1.002,0-1.82-0.811-1.818-1.818   c0-0.996,0.814-1.816,1.818-1.82c0.997,0.002,1.815,0.824,1.815,1.822C61.686,26.792,60.872,27.605,59.87,27.605z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M83.009,41.038c0-2.66-2.155-4.814-4.815-4.814c-2.657-0.002-4.812,2.156-4.812,4.816l0.002,20.159   c0.001,2.662,2.155,4.814,4.816,4.812c2.657,0,4.812-2.15,4.812-4.814L83.009,41.038z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M71.523,37.131L71.523,37.131l-43.04,0.008l0.007,31.241c-0.001,0.819,0.207,1.581,0.546,2.267   c0.837,1.697,2.567,2.873,4.591,2.873h3.498l0.004,10.666c0,0.332,0.034,0.655,0.098,0.969C37.676,87.348,39.618,89,41.94,89   c0.332,0,0.657-0.034,0.971-0.098c2.194-0.45,3.845-2.394,3.845-4.719l-0.003-10.666h6.499v10.666   c0.003,2.323,1.657,4.269,3.848,4.715c0.313,0.064,0.637,0.098,0.969,0.098c2.66,0.002,4.815-2.159,4.815-4.816l-0.003-10.662   l3.512-0.002c0.961,0,1.851-0.281,2.621-0.742c1.5-0.897,2.516-2.521,2.518-4.398L71.523,37.131L71.523,37.131z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.801,36.229c-2.659,0-4.813,2.159-4.814,4.814l0.003,20.161c0.001,1.683,0.862,3.155,2.164,4.017   c0.761,0.504,1.671,0.801,2.651,0.803c2.328-0.004,4.269-1.65,4.716-3.848c0.064-0.314,0.097-0.639,0.097-0.972V41.042   C26.618,38.385,24.46,36.229,21.801,36.229z"
  }));
};

var _default = AndroidIcon;
exports["default"] = _default;
//# sourceMappingURL=AndroidIcon.js.map